import React from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';
import { MeetingsListViewModel } from '../../meetings-list.viewmodel';
import { ASSIGN_ROOM_MESSAGE_TEXT } from './assign-room-form.texts';
import { OERadioOptions } from '../../../../../global/oe-radio-options/oe-radio-options';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { connectionVersionOptions } from './assign-room-form-data.viewmodal';
import { ConnectionVersion } from '../../../../../../constants/common.constants';

interface IProps {
    vm: MeetingsListViewModel;
    intl: IntlShape;
}

const AssignRoomFormPresentation = injectIntl(mobxReact.observer((props: IProps) => {
    const formData = props.vm.getAssignRoomFormDataVM();

    return (
        <form className='oe-form assign-room-form'>
            <div className='oe-form_body'>
                <p>{props.intl.formatMessage(ASSIGN_ROOM_MESSAGE_TEXT)}</p>
                <FormField>
                    <OERadioOptions
                        value={formData.connectionVersion}
                        onOptionToggle={(value: ConnectionVersion) => formData.setConnectionVersionField(value)}
                        options={connectionVersionOptions(props.intl)}
                        isIconFirst
                    />
                </FormField>
            </div>
        </form>
    );
}));

export { AssignRoomFormPresentation };
